import React from 'react'
import { useSelector } from 'react-redux'
import { option, getValue } from '../../../lib/common'
import { getProjectMappingElements } from '../../../lib/project'
import { PortalCreatableSelect } from '../../Main/SelectControls'

export default function FocusByField({ settings, onChangeLat, onChangeLng, pageID }) {
  let mappingElements = useSelector((state) => getProjectMappingElements(state, true))
  const valueLat = getValue(mappingElements, settings.getIn(['focusOn', 'field', 'lat', 'value']))
  const valueLng = getValue(mappingElements, settings.getIn(['focusOn', 'field', 'lng', 'value']))

  return (
    <div>
      <div className="predefined-page-list form-group">
        <label className="field-label">Latitude</label>
        <PortalCreatableSelect
          placeholder="Type to search elements"
          isElementStyle={true}
          isClearable={false}
          value={!valueLat ? option('Type to search elements', '') : valueLat}
          options={mappingElements}
          onChange={onChangeLat}
          menuPortalTarget={document.body}
          openMenuOnFocus
          isSearchable
        />
      </div>
      <div className="predefined-page-list form-group">
        <label className="field-label">Longitude</label>
        <PortalCreatableSelect
          placeholder="Type to search elements"
          isElementStyle={true}
          isClearable={false}
          value={!valueLng ? option('Type to search elements', '') : valueLng}
          options={mappingElements}
          onChange={onChangeLng}
          menuPortalTarget={document.body}
          openMenuOnFocus
          isSearchable
        />
      </div>
    </div>
  )
}
